module.exports = __webpack_public_path__ + "media/images/redox/RedoxInteractive_Logo_Vertical-e305dc01ed4fde68cddbe01329ed4ba1.png";